import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import Fetchable from '~/commons/components/util/Fetchable';
import Html from '~/commons/components/util/Html';
import Page from '../layout/Page';
import Card from '../layout/Card';
import env from '../../../commons/config/env';

const PageHome = () => {
  const { i18n, t } = useTranslation();
  const th = (h) => t(`nav.${h}`, h);

  return (
    <Page>
      <Card
        grid="md"
        image="/assets/img/home-characters.gif"
      >
        <Fetchable req={{ url: '/api/views/u?key=home' }}>
          {(home) => (
            <>
              <h1 className="display-3 fw-bold">
                {i18n.pickLng(home.title)}
              </h1>
              <div className="mb-3">
                <Html>
                  {i18n.pickLng(home.body)}
                </Html>
              </div>
              {!env.user && (
                <>
                  <Link className="btn btn-rock-3 me-3 fontBorder" to="/auth/register">
                    {th('Register')}
                  </Link>
                  <Link className="btn btn-rock-3 fontBorder" to="/auth">
                    {th('Login')}
                  </Link>
                </>
              )}
            </>
          )}
        </Fetchable>
      </Card>
    </Page>
  );
};

export default PageHome;
